import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RouteChangeTracker from './components/Analytics/RouteChangeTracker'; // Adjust path if needed
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/home';
import AboutPage from './pages/about';
import ContactPage from './pages/contact';
import ServicesPage from './pages/services';
import CloudSolutionsPage from './pages/services/cloud-solutions';
import ConsultingPage from './pages/services/consulting';
import MobileAppsPage from './pages/services/mobile-apps';
import WebDevelopmentPage from './pages/services/web-development';
import ScrollToTop from './components/common/ScrollToTop';
import PortfolioPage from './pages/portfolio';
import TermsOfService from './pages/terms';
import PrivacyPolicy from './pages/privacy';

function App() {
  return (
    <Router>
      {/* Add RouteChangeTracker here, it will only run its logic in production */}
      <RouteChangeTracker />

      <ScrollToTop />
      <div className="min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/cloud-solutions" element={<CloudSolutionsPage />} />
          <Route path="/services/consulting" element={<ConsultingPage />} />
          <Route path="/services/mobile-apps" element={<MobileAppsPage />} />
          <Route path="/services/web-development" element={<WebDevelopmentPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;  // Add this line to export App as the default export